import { createFormModalConfig, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX, MenuCategories, MenuSubcategories } from '@zendra/shared';
import { InventoryProjection } from './inventory-projection';

export const INVENTORY_PROJECTION_CONFIG = {
  localizationKey: 'LanguageService::Menu:ExecuteInventoryProjection',
  permission: 'PlanningInventory.CalculationResults.Edit',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Inventory + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.TransactionsInventory + MENU_NAME_SUFFIX,
};

export const INVENTORY_PROJECTION_MODAL_CONFIG = createFormModalConfig({
  component: InventoryProjection,
  title: INVENTORY_PROJECTION_CONFIG.localizationKey,
  subTitle: 'LanguageService::InventoryProjection:SubTitle',
  confirmLabel: 'LanguageService::Confirm',
  dismissLabel: 'LanguageService::Close',
});
